export const serviceContent = {
  inventory: {
    title: 'Inventory Management',
    description:
      'Advanced inventory control system that gives you complete visibility and control over your stock across all locations. Never run out of stock or overstock again.',
    features: [
      'Multi-warehouse inventory tracking with real-time synchronization',
      'Automated reorder points with smart replenishment suggestions',
      'Barcode and QR code scanning for fast stock movements',
      'Batch and serial number tracking for traceability',
      'Expiry date management with automated alerts',
      'Stock transfer between locations with approval workflows',
      'Cycle counting and physical inventory reconciliation',
      'Inventory valuation methods (FIFO, LIFO, Average Cost)',
      'Low stock alerts and automated purchase order creation',
    ],
    benefits: [
      'Reduce inventory holding costs by 30%',
      'Eliminate stockouts and lost sales',
      'Improve inventory accuracy to 99%+',
      'Faster stock movements and fulfillment',
      'Better demand forecasting',
      'Reduced obsolete inventory',
    ],
    metrics: [
      'Real-time stock levels across all locations',
      'Inventory turnover ratio tracking',
      'Stock aging analysis',
      'ABC analysis for inventory prioritization',
    ],
  },
  crm: {
    title: 'Customer Relationship Management',
    description:
      'Powerful CRM platform that helps you build stronger customer relationships, close more deals, and grow your business. Everything you need to manage the entire customer lifecycle.',
    features: [
      '360° customer view with complete interaction history',
      'Sales pipeline management with customizable stages',
      'Lead scoring and qualification automation',
      'Email integration with tracking and templates',
      'Task and activity management with reminders',
      'Quote and proposal generation',
      'Contract management and renewal tracking',
      'Customer segmentation and targeted campaigns',
      'Sales forecasting and performance analytics',
    ],
    benefits: [
      'Increase sales conversion by 25%',
      'Shorten sales cycle duration',
      'Improve customer retention rates',
      'Better sales team productivity',
      'Enhanced customer satisfaction',
      'More accurate revenue forecasting',
    ],
    metrics: [
      'Pipeline value and win rates',
      'Average deal size and cycle time',
      'Customer lifetime value (CLV)',
      'Sales rep performance dashboards',
    ],
  },
  financial: {
    title: 'Financial Management',
    description:
      'Comprehensive accounting and financial management system that automates your financial processes, ensures compliance, and provides real-time insights into your business finances.',
    features: [
      'Automated invoicing with customizable templates',
      'Accounts payable and receivable management',
      'Bank reconciliation with automatic matching',
      'Expense tracking and approval workflows',
      'Multi-currency support with automatic conversion',
      'Tax calculation and compliance reporting',
      'Financial statements (P&L, Balance Sheet, Cash Flow)',
      'Budget planning and variance analysis',
      'Fixed asset management and depreciation',
    ],
    benefits: [
      'Reduce accounting errors by 95%',
      'Faster month-end closing',
      'Improved cash flow management',
      'Better financial visibility',
      'Simplified tax compliance',
      'Lower accounting costs',
    ],
    metrics: [
      'Accounts receivable aging',
      'Cash flow projections',
      'Profit margins by product/service',
      'Key financial ratios and KPIs',
    ],
  },
  sales: {
    title: 'Sales & Order Management',
    description:
      'Streamlined sales and order processing system that automates your quote-to-cash process. Handle complex pricing, approvals, and fulfillment with ease.',
    features: [
      'Quote creation with product catalog and pricing rules',
      'Discount and approval workflows',
      'Order processing with inventory allocation',
      'Backorder management and partial fulfillment',
      'Shipping integration with label printing',
      'Payment processing and gateway integration',
      'Sales commission calculation and tracking',
      'Customer portal for order tracking',
      'Returns and refunds management',
    ],
    benefits: [
      'Faster quote-to-cash cycle',
      'Reduce order processing errors',
      'Improve order fulfillment speed',
      'Better pricing control',
      'Enhanced customer experience',
      'Accurate commission tracking',
    ],
    metrics: [
      'Order fulfillment rate and speed',
      'Average order value trends',
      'Sales by product, region, rep',
      'Quote conversion rates',
    ],
  },
  project: {
    title: 'Project Management',
    description:
      'Collaborative project management platform that helps teams plan, execute, and deliver projects on time and within budget. Perfect for service-based businesses and internal projects.',
    features: [
      'Project planning with Gantt charts and timelines',
      'Task assignment and dependency management',
      'Time tracking and timesheet approval',
      'Resource allocation and capacity planning',
      'Budget tracking and expense management',
      'Document management and file sharing',
      'Milestone tracking and deliverable management',
      'Team collaboration with comments and mentions',
      'Project templates for recurring work',
    ],
    benefits: [
      'Improve project delivery rates',
      'Better resource utilization',
      'Accurate project profitability',
      'Enhanced team collaboration',
      'Reduced project overruns',
      'Improved client satisfaction',
    ],
    metrics: [
      'Project completion rates',
      'Budget vs actual tracking',
      'Resource utilization rates',
      'Time to completion trends',
    ],
  },
  analytics: {
    title: 'Business Intelligence & Analytics',
    description:
      'Advanced analytics and reporting platform that transforms your business data into actionable insights. Make data-driven decisions with confidence.',
    features: [
      'Customizable dashboards with drag-and-drop widgets',
      'Real-time KPI tracking and monitoring',
      'Automated report generation and scheduling',
      'Predictive analytics and forecasting',
      'Data visualization with charts and graphs',
      'Custom report builder with filters',
      'Export to Excel, PDF, and other formats',
      'Role-based access to reports and data',
      'Mobile-optimized analytics dashboard',
    ],
    benefits: [
      'Faster decision-making',
      'Identify trends and opportunities',
      'Improve operational efficiency',
      'Better strategic planning',
      'Reduced reporting time',
      'Data-driven culture',
    ],
    metrics: [
      'Custom KPIs by department',
      'Trend analysis and forecasts',
      'Comparative period analysis',
      'Drill-down capabilities',
    ],
  },
}
